var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgPattern2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 181,
    viewBox: "0 0 174 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#44FFA1",
    transform: "rotate(-56 110.742 58.398)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 56.621,
    rx: 27.5,
    ry: 55.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.633,
    cy: 56.504,
    rx: 27.5,
    ry: 55.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.878,
    cy: 56.117,
    opacity: 0.75,
    rx: 27.5,
    ry: 55.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.511,
    cy: 56,
    opacity: 0.5,
    rx: 27.5,
    ry: 55.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.703,
    cy: 56.712,
    opacity: 0.25,
    rx: 27.5,
    ry: 55.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern2);
export default __webpack_public_path__ + "static/media/bg-pattern-2.4c1e835bb8483df3ccf9d1bbe7f8a2b6.svg";
export { ForwardRef as ReactComponent };